import { ChangeDetectorRef, Component, OnInit } from '@angular/core';
import { Router } from '@angular/router';
import { BaseComponent } from '../../../../../shared/components/base/base/base.component';
import { DashboardService } from '../../services/dashboard.service';
import { DashboardData, DashboardOrderItem } from '../../models/dashboard-data.model';
import { OrderStatus } from '../../../../../core/enums/order-status.enum';

@Component({
  selector: 'app-home',
  templateUrl: './home.component.html',
  styleUrls: ['./home.component.scss']
})
export class HomeComponent extends BaseComponent implements OnInit {

  loading = true;
  data: DashboardData;

  readonly statusTiles: { statusValue: OrderStatus; countKey: keyof DashboardData; cssClass: string }[] = [
    { statusValue: OrderStatus.New,                countKey: 'ordersNew',                cssClass: 'status-new' },
    { statusValue: OrderStatus.ToPickup,           countKey: 'ordersToPickup',           cssClass: 'status-to-pickup' },
    { statusValue: OrderStatus.PickupInProgress,   countKey: 'ordersPickupInProgress',   cssClass: 'status-pickup-progress' },
    { statusValue: OrderStatus.ReceivedFromSeller, countKey: 'ordersReceivedFromSeller', cssClass: 'status-received' },
    { statusValue: OrderStatus.ReceivedFromCarrier,countKey: 'ordersReceivedFromCarrier',cssClass: 'status-received' },
    { statusValue: OrderStatus.ToPay,              countKey: 'ordersToPay',              cssClass: 'status-to-pay' },
    { statusValue: OrderStatus.InComplaint,        countKey: 'ordersInComplaint',        cssClass: 'status-complaint' },
    { statusValue: OrderStatus.Paid,               countKey: 'ordersPaid',               cssClass: 'status-paid' },
    { statusValue: OrderStatus.ForSale,            countKey: 'ordersForSale',            cssClass: 'status-for-sale' },
    { statusValue: OrderStatus.Sold,               countKey: 'ordersSold',               cssClass: 'status-sold' },
  ];

  constructor(private dashboardService: DashboardService, private router: Router, private cdr: ChangeDetectorRef) {
    super();
    this.getVehicleName = this.getVehicleName.bind(this);

    this.data = {
      unpickedVehiclesAfterDeadline: 0,
      unpickedVehiclesWithUpcomingDeadline: 0,
      unpickedVehiclesWithoutDeadline: 0,
      ordersTotal: 0,
      ordersNew: 0,
      ordersToPickup: 0,
      ordersPickupInProgress: 0,
      ordersReceivedFromSeller: 0,
      ordersReceivedFromCarrier: 0,
      ordersToPay: 0,
      ordersInComplaint: 0,
      ordersPaid: 0,
      ordersForSale: 0,
      ordersSold: 0,
      recentOrders: []
    };
  }

  async ngOnInit(): Promise<void> {
    this.loading = true;
    try {
      this.data = await this.dashboardService.getAsync();
    } finally {
      this.loading = false;
      this.cdr.detectChanges();
    }
  }

  getTileCount(countKey: keyof DashboardData): number {
    return this.data[countKey] as number;
  }

  getRecentOrderStatusClass(status: number): string {
    switch (status) {
      case OrderStatus.New:                return 'status-new';
      case OrderStatus.ToPickup:           return 'status-to-pickup';
      case OrderStatus.PickupInProgress:   return 'status-pickup-progress';
      case OrderStatus.ReceivedFromSeller:
      case OrderStatus.ReceivedFromCarrier: return 'status-received';
      case OrderStatus.ToPay:              return 'status-to-pay';
      case OrderStatus.InComplaint:        return 'status-complaint';
      case OrderStatus.Paid:               return 'status-paid';
      case OrderStatus.ForSale:            return 'status-for-sale';
      case OrderStatus.Sold:               return 'status-sold';
      default:                             return 'status-new';
    }
  }

  getVehicleName(item: DashboardOrderItem): string {
    const makeName = item.make != null ? this.getMakeName(item.make) : '';
    const model = item.model ?? '';
    return [makeName, model].filter(Boolean).join(' ');
  }

  onStatusTileClick(tile: { statusValue: OrderStatus }): void {
    this.router.navigate(['/orders'], { queryParams: { status: tile.statusValue } });
  }

  onAlertTileClick(filterKey: 'unpickedAfterDeadline' | 'unpickedWithUpcomingDeadline' | 'unpickedWithoutDeadline'): void {
    console.log('onAlertTileClick', { [filterKey]: true });
    this.router.navigate(['/orders'], { queryParams: { [filterKey]: true } });
  }

  onOrderRowClick(e: any): void {
    if (e.data?.publicId) {
      this.router.navigate(['/orders/edit', e.data.publicId]);
    }
  }
}
